// extracted by mini-css-extract-plugin
export default {"nodeContainer":"node_nodeContainer__fAxq9","node":"node_node__w3V-S","treeLabel":"node_treeLabel__t0m7+","delete":"node_delete__AnvhS"};